(function ($, window) {
	'use strict';

	$(function () {
		function setAlertHeight(alertSystem) {
			const alertHeight = alertSystem.offsetHeight;
			root.style.setProperty('--alert-bar-height', `${alertHeight}px`);
		}

		function createObservers(alertSystem) {
			let adminBarHeight = 0;

			if (document.body.classList.contains('admin-bar')) {
				adminBarHeight = getComputedStyle(root).getPropertyValue('--custom-admin-bar-height').trim();
				adminBarHeight = parseInt(adminBarHeight);

				if (isNaN(adminBarHeight)) adminBarHeight = 0;
			}

			const resizeObserver = new ResizeObserver((entries) => {
				for (const entry of entries) {
					if (entry.target === alertSystem) {
						setAlertHeight(alertSystem);
					}
				}
			});

			return { resizeObserver };
		}

		const root = document.querySelector(':root');
		const alertSystem = document.querySelector('.js-alert');

		if (alertSystem) {
			const closeButton = alertSystem.querySelector('.js-alert__close');
			let alertString = '';

			const { resizeObserver } = createObservers(alertSystem);

			resizeObserver.observe(alertSystem);

			// Check if we've got an alert cookie.
			if (Cookies.get('rb_alert_viewed')) {
				alertString = `${Cookies.get('rb_alert_viewed')},`;
			}

			closeButton.addEventListener('click', (ev) => {
				ev.preventDefault();
				// Get the hash from the data attributes.
				const alertHash = alertSystem.dataset.alertHash;

				// Temporarily close it.
				alertSystem.style.marginTop = `${alertSystem.offsetHeight * -1}px`;

				// Then remove it.
				setTimeout(() => {
					alertSystem.parentNode.removeChild(alertSystem);
				}, 300);

				// Then add a cookie so we don't render it in WP anymore
				Cookies.set('rb_alert_viewed', `${alertString}${alertHash}`);

				// Fire an event elements can listen for.
				const closeEvent = new CustomEvent('close_alert');
				window.dispatchEvent(closeEvent);

				root.style.setProperty('--alert-bar-height', '0px');

				resizeObserver.disconnect();
			});

			document.body.classList.add('alert-banner-visible');
			setAlertHeight(alertSystem);
		}
	});
})(jQuery, window);
